import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import RotationMeter from './RotationKpiMeter';
import Menu from '../../form/SelectionMenu';
import BadgeCollect from '../badges/BadgeCollect';
import Resources from '../resourceLinks/ResourceLinks';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as kpiHelper from '../../../helpers/kpiHelper';
import * as kpiConstants from '../../../constants/kpiConstants';
import * as assetConstants from '../../../constants/assetConstants';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as kpiModels from '../../../models/kpiModels';
import * as localStorage from '../../../localStorage/localStorage';
import * as keyboardConstants from '../../../constants/keyboardConstants';

class KpiResultsPanel extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            lang: this.props.lang,
            kpiMenuData: this.props.kpiMenuData,
            userDataKpi: this.props.userDataKpi,
            kpiData: this.props.kpiData,
            completeKpis:  this.props.completeKpis,
            allowKpiRedraw: true,
            locale: appHelper.getLocalData(this.props.kpiData),
            assets: {
                screenAsset: {
                    src: "",
                    pose: "",
                    position: ""
                }
            },
            updateAssets: false,
            hasBadges: appHelper.isDefined(this.props.kpiData.badge_id) && this.props.kpiData.badge_id > 0 && this.props.kpiData.badge_id !== 0 && this.props.userDataKpi.currentScoreRange === objectConstants.RESULT_BEST,
            badgesCollected: false,
            badge: {},
            hasResources: false,
            resourcesAreComplete: false,
            checkComplete: false,
            isComplete: false,
            checkBadge: false,
        };

        this.getAssetTarget = this.getAssetTarget.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getAssetType = this.getAssetType.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.onBadgeCollected = this.onBadgeCollected.bind(this);
        this.getBadge = this.getBadge.bind(this);
        this.onResourcesComplete = this.onResourcesComplete.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.getKpiIsComplete = this.getKpiIsComplete.bind(this);
        this.getPreviousKpi = this.getPreviousKpi.bind(this);
        this.getNextKpi = this.getNextKpi.bind(this);
        this.setKpi = this.setKpi.bind(this);
        this.getAccessiblePreviousKpi = this.getAccessiblePreviousKpi.bind(this);
        this.getAccessibleNextKpi = this.getAccessibleNextKpi.bind(this);
        this.getAccessibleKpi = this.getAccessibleKpi.bind(this);
    }

    componentDidMount() {
        if (this.state.hasBadges) {
            this.getBadge(this.state.kpiData.badge_id);
        }

        let getAssets = this.getAssets;

        setTimeout(function () {
            getAssets();
        }, 500);


        // this.getAssets();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userDataKpi !== nextProps.userDataKpi) {
            this.setState({
                userDataKpi: Object.assign({}, nextProps.userDataKpi),
                updateAssets: true,
                hasBadges: appHelper.isDefined(nextProps.kpiData.badge_id) && nextProps.kpiData.badge_id > 0 && nextProps.kpiData.badge_id !== 0 && nextProps.userDataKpi.currentScoreRange === objectConstants.RESULT_BEST,
                checkBadge: true,
            });
        }

        if (this.state.kpiData !== nextProps.kpiData) {
            this.setState(
                {
                    kpiData: Object.assign({}, nextProps.kpiData),
                    locale: Object.assign({}, appHelper.getLocalData(nextProps.kpiData)),
                    updateAssets: true,
                    hasBadges: appHelper.isDefined(nextProps.kpiData.badge_id) && nextProps.kpiData.badge_id > 0 && nextProps.kpiData.badge_id !== 0 && nextProps.userDataKpi.currentScoreRange === objectConstants.RESULT_BEST,
                    checkBadge: true,
                }
            );
        }

        if (this.state.kpiMenuData !== nextProps.kpiMenuData) {
            this.setState({kpiMenuData: Object.assign({}, nextProps.kpiMenuData)});
        }

        if (this.state.completeKpis !== nextProps.completeKpis) {
            this.setState({completeKpis: Object.assign([], nextProps.completeKpis)});
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.kpiData)
            });
        }


    }

    componentDidUpdate() {

        if (this.state.updateAssets) {
            this.getAssets();
            this.getBadge(this.state.kpiData.badge_id);
        }

        if (this.state.checkComplete) {
            this.onComplete();
        }

        if (this.state.checkBadge) {
            this.getBadge(this.state.kpiData.badge_id);
        }
    }

    onComplete() {


        if (this.state.resourcesAreComplete && appHelper.isDefined(this.props.onComplete)) {
            this.props.onComplete(this.state.kpiData);
            this.setState({checkComplete: false, isComplete: this.state.resourcesAreComplete});
        }
    }

    getBadge(badge_id) {
        this.setState({checkBadge: false});
        let badges = localStorage.contentData.experience.badges;
        this.setState({badge: Object.assign({}, appHelper.getArrayObjectByKey(badges, "badge_id", badge_id))});
    }

    getAssetTarget() {

        //console.log(`getAssetTarget`,this.state.userDataKpi);
        if (this.state.userDataKpi.currentScoreRange === objectConstants.RESULT_TYPE_BEST) {
            return kpiConstants.GREEN_ASSET;
        } else if (this.state.userDataKpi.currentScoreRange === objectConstants.RESULT_TYPE_OK) {
            return kpiConstants.YELLOW_ASSET;
        } else if (this.state.userDataKpi.currentScoreRange === objectConstants.RESULT_TYPE_POOR) {
            return kpiConstants.RED_ASSET;
        }
    }

    getAssets() {
        let assetTarget = this.getAssetTarget();
        //console.log(`assetTarget`,assetTarget);
        let screenAsset = this.getAssetType(this.state.kpiData.assets[0][assetTarget]);

        let resourceLinks = appHelper.setResourceLinks(this.state.kpiData.assets[0][assetTarget]);
        let hasRequiredResources = appHelper.hasRequiredResources(resourceLinks);


        this.setState({
            updateAssets: false,
            assets: Object.assign({}, this.state.assets, {
                screenAsset: screenAsset
            }),
            resourceLinks: Object.assign([], resourceLinks),
            hasResources: resourceLinks.length > 0,
            resourcesAreComplete: resourceLinks.length === 0 || !hasRequiredResources,
            checkComplete: true
        });


    }

    getAssetType(asset) {
        let returnAsset = {};
        if (asset.constant === assetConstants.ASSET_TYPE_ID_CHARACTER) {
            let screenCharacter = appHelper.getCharacterAsset(asset);
            returnAsset = appHelper.getCharacterPose(screenCharacter, asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_ICON) {
            returnAsset = appHelper.getIconAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_IMAGE) {
            returnAsset = appHelper.getImageAsset(asset);
        }
        returnAsset = appHelper.isDefined(returnAsset.locale) ? appHelper.getLocalData(returnAsset) : returnAsset;

        if(appHelper.isDefined(asset.constant) && !appHelper.isDefined(returnAsset.type)){
            returnAsset = Object.assign({},returnAsset,{
                type: asset.constant
            });
        }
        return returnAsset;
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    onBadgeCollected() {
        this.setState({badgesCollected: true});
        //this.hide();
    }


    onResourcesComplete() {
        if (!this.state.resourcesAreComplete) {
            this.setState({resourcesAreComplete: true, checkComplete: true});
        }
    }

    getKpiIsComplete(kpi_id){
        let index = appHelper.getArrayObjectIndexByKey(this.state.completeKpis,"kpi_id",kpi_id);
        return index > -1 ? "complete" : "";
    }

    setKpi(kpi){
        this.state.kpiMenuData.onMenuSelect(kpi);
    }

    getPreviousKpi(){
        let index = appHelper.getArrayObjectIndexByKey(this.state.kpiMenuData.menu,"constant",this.state.kpiData.kpi_id);
        let prevIndex = this.state.kpiMenuData.menu.length - 1;
        if(index > 0){
            prevIndex = index - 1;
        }
        this.state.kpiMenuData.onMenuSelect(this.state.kpiMenuData.menu[prevIndex]);
    }

    getNextKpi(){
        let index = appHelper.getArrayObjectIndexByKey(this.state.kpiMenuData.menu,"constant",this.state.kpiData.kpi_id);
        let nextIndex = 0;
        if(index < this.state.kpiMenuData.menu.length - 1){
            nextIndex = index + 1;
        }

        this.state.kpiMenuData.onMenuSelect(this.state.kpiMenuData.menu[nextIndex]);

        // this.state.kpiMenuData.onMenuSelect(this.state.kpiMenuData.menu[index + 1]);
    }

    getAccessiblePreviousKpi(){
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.getPreviousKpi();
        }
    }
    getAccessibleNextKpi(){
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.getNextKpi();
        }
    }
    getAccessibleKpi(kpi){
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.setKpi(kpi);
        }
    }

    render() {
        return (
            <div className={`kpi-results-panel ${this.state.userDataKpi.currentScoreRange}`} ref={`kpi-results-panel`}>
                <div className="results-row">
                    {
                        appHelper.isDefined(this.state.assets.screenAsset.src) && this.state.assets.screenAsset.src.length > 0
                            ?
                            <div className="kpi-results-column">
                                <div className="kpi-result-asset">
                                    <img src={this.getImagePath(this.state.assets.screenAsset.src)} alt=""/>
                                </div>
                            </div>
                            :
                            null
                    }
                    <div className="kpi-results-column flex-1">
                        {appHelper.isDefined(this.state.kpiMenuData) && this.state.kpiMenuData.menu.length > 1
                            ?
                            <Menu menuData={this.state.kpiMenuData.menu}
                                  currentSelection={this.state.kpiMenuData.currentKpi}
                                  onMenuSelect={this.state.kpiMenuData.onMenuSelect}
                                  idKey={this.state.kpiMenuData.idKey}
                                  labelKey={this.state.kpiMenuData.labelKey}/>
                            :
                            <div><strong>{this.state.locale.long_title}</strong></div>
                        }

                        <div
                            dangerouslySetInnerHTML={{__html: this.state.locale[kpiHelper.getResultKpiKey(this.state.userDataKpi)]}}/>
                        {
                            this.state.hasResources
                                ?

                                <Resources resources={this.state.resourceLinks}
                                           onResourcesComplete={this.onResourcesComplete}/>

                                :
                                null
                        }
                    </div>
                    <div className="kpi-results-column">
                        {appHelper.isDefined(this.state.kpiMenuData) && this.state.kpiMenuData.menu.length > 1
                            ?
                            <div>
                                <div className="kpi-nav-list">
                                    <div role="button" tabIndex="0" className="back-nav" onClick={this.getPreviousKpi} onKeyDown={this.getAccessiblePreviousKpi}/>
                                    {this.state.kpiMenuData.menu.map(kpi =>
                                        <div key={kpi.constant} onClick={() => this.setKpi(kpi)} onKeyDown={() => this.getAccessibleKpi(kpi)} className={`kpi-indicator ${this.getKpiIsComplete(kpi.constant)}`} role="button" tabIndex="0"/>
                                    )}
                                    <div className="next-nav" role="button" tabIndex="0"  onClick={this.getNextKpi}  onKeyDown={this.getAccessibleNextKpi}/>
                                </div>
                            </div>
                            :
                            null
                        }
                        <div className="kpi-result-meter">
                            <RotationMeter bite_id={this.props.bite_id}
                                           kpiDefaults={this.state.kpiData}
                                           meterParams={kpiModels.PRIMARY_KPI_ROTATION_METER_PARAMS}
                                           displayState={kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL}
                                           allowKpiRedraw={this.state.allowKpiRedraw}
                            />
                        </div>
                    </div>
                </div>

                {
                    this.state.hasBadges && appHelper.isDefined(this.state.badge.badge_id)
                        ?
                        <div className="results-row">

                            <div className="kpi-result-asset" />
                            <div className="kpi-results-column flex-1">

                                <BadgeCollect key={this.state.badge.badge_id}
                                              badge_id={this.state.badge.badge_id} bite_id={this.props.bite_id}
                                              asset_id={this.props.asset_id}
                                              onCollected={this.onBadgeCollected}/>
                            </div>
                        </div>



                        : null
                }

            </div>
        );
    }
}

KpiResultsPanel.propTypes = {
    userDataKpi: PropTypes.object.isRequired,
    kpiData: PropTypes.object.isRequired,
    asset_id: PropTypes.number,
    bite_id: PropTypes.number,
    kpiMenuData: PropTypes.object,
    completeKpis: PropTypes.array,
    lang: PropTypes.string.isRequired,
    onComplete: PropTypes.func,
};

KpiResultsPanel.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, appDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(KpiResultsPanel);



/** WEBPACK FOOTER **
 ** ./src/components/objects/kpi/KpiResultsPanel.js
 **/